import { Category } from "../models/Category";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getCategories() {
	return getRequest<Category[]>(`${host}/api/category`);
}

export async function updateCategory(category: Category) {
	return patchRequest<void>(
		`${host}/api/category/${category.id}`, category
	);
}

export async function addCategory(newCategory: Category) {
	const { id, ...objectWithoutId } = newCategory;
	return postRequest<Category | undefined>(
		`${host}/api/category`, objectWithoutId
	);
}

export async function deleteCategory(id: string) {
	return deleteRequest(`${host}/api/category/${id}`)
}